import { getGameStaticData, createGamePkSelector } from '@gameday/utils/selectors/getGameStaticData';
import { getLeagueContextDataSelector } from '@gameday/utils/selectors/getContextData';

const NULL = null;
const defaultGameContext = 'non-mlb';

const isValidProp = (prop) => {
    return !!(typeof prop !== 'undefined' && prop !== NULL);
};

const getConfig = (state) => state?.config;
const getContextConfigs = (state) => getConfig(state)?.context?.configs;
const getPOTGGameTypes = (state) => getConfig(state)?.potgGameTypes;
const EMPTY = Object.freeze({});

/*
  this is a function that takes a config object as parameter;
  {disablePotg: Boolean, gameTypes: Array, minYear: nubmber season: string, type:string, homeContext: string, awayContext: string}
  return a boolean value to determine if we should show POTG
*/

export const visibilityHelper = ({ disablePotg, gameTypes, minYear, season, type }) => {
    const hasDisablePotg = isValidProp(disablePotg);
    const hasGameTypes = isValidProp(gameTypes) && gameTypes instanceof Set && gameTypes?.size > 0;
    const hasMinYear = isValidProp(minYear);
    const areAllPropsValid = hasDisablePotg && hasGameTypes && hasMinYear && season && type;
    if (!areAllPropsValid) {
        return false;
    }
    const isValidGameType = gameTypes.has(type);
    const configSeason = parseInt(season);
    const isValidSeason = configSeason >= minYear;

    return !disablePotg && isValidSeason && isValidGameType;
};

export const getPOTGVisibility = createGamePkSelector(
    [getGameStaticData, getLeagueContextDataSelector, getContextConfigs, getConfig, getPOTGGameTypes],
    (gameStaticData, contextData, contextConfigsData, configData, potgGameTypes) => {
        const { enablePOTG } = configData || EMPTY;
        const gamePk = gameStaticData?.gamePk;

        if (enablePOTG) {
            return {
                showPOTG: true,
                gamePk
            };
        }
        const { season, type } = gameStaticData || EMPTY;
        const { homeContext, awayContext } = contextData || EMPTY;
        const gameContextKey = homeContext || awayContext;
        const { disablePlayerOfTheGame, playerOfTheGameMinYear } = contextConfigsData?.[gameContextKey] || contextConfigsData?.[defaultGameContext] || EMPTY;

        const showPOTG = visibilityHelper({ disablePotg: disablePlayerOfTheGame, gameTypes: potgGameTypes, minYear: playerOfTheGameMinYear, season, type });
        return {
            showPOTG,
            gamePk
        };
    }
);

export default getPOTGVisibility;
